export default {
  SET_STATE: 'publications/SET_STATE',
  FETCH_PUBLICATIONS: 'publications/FETCH_PUBLICATIONS',
  CREATE_PUBLICATION: 'publications/CREATE_PUBLICATION',
  FETCH_SINGLE: 'publications/FETCH_SINGLE',
  UPDATE_PUBLICATION: 'publications/UPDATE_PUBLICATION',
  PERFORM_ACTION_PUBLICATION: 'publications/PERFORM_ACTION_PUBLICATION',
  FETCH_TRENDING_PUBLICATIONS: 'publications/FETCH_TRENDING_PUBLICATIONS',
}
